module.exports = __webpack_public_path__ + "img/paired.10d9493d.svg";